<template>
    <b-jumbotron class="py-5">
        <h3 class="text-center mb-3">Secciones</h3>
        <div class="d-lg-none">
            <b-tabs
                pills
                justified
                nav-wrapper-class="w-100"
            >
                <b-tab
                    :title-item-class="bTabItemClasses"
                    :title-link-class="bTabLinkClasses"
                    title="Asignaturas"
                    :active="$route.name === 'admin-courses'"
                    @click="$router.push({name: 'admin-courses'})"
                />
                <b-tab
                    :title-item-class="bTabItemClasses"
                    :title-link-class="bTabLinkClasses"
                    title="Docentes"
                    :active="$route.name === 'admin-professors'"
                    @click="$router.push({name: 'admin-professors'})"
                />
                <b-tab
                    :title-item-class="bTabItemClasses"
                    :title-link-class="bTabLinkClasses"
                    title="Estudiantes"
                    :active="$route.name === 'admin-students'"
                    @click="$router.push({name: 'admin-students'})"
                />
            </b-tabs>
        </div>

        <div class="d-none d-lg-block">
            <b-tabs
                pills
                vertical
                nav-wrapper-class="w-100"
            >
                <b-tab
                    :title-item-class="bTabItemClasses"
                    :title-link-class="bTabLinkClasses"
                    title="Asignaturas"
                    :active="$route.name === 'admin-courses'"
                    @click="$router.push({name: 'admin-courses'})"
                />
                <b-tab
                    :title-item-class="bTabItemClasses"
                    :title-link-class="bTabLinkClasses"
                    title="Docentes"
                    :active="$route.name === 'admin-professors'"
                    @click="$router.push({name: 'admin-professors'})"
                />
                <b-tab
                    :title-item-class="bTabItemClasses"
                    :title-link-class="bTabLinkClasses"
                    title="Estudiantes"
                    :active="$route.name === 'admin-students'"
                    @click="$router.push({name: 'admin-students'})"
                />
            </b-tabs>
        </div>
    </b-jumbotron>
</template>

<script>
export default {
    name: 'AdminSectionSelector',
    data () {
        return {
            bTabItemClasses: ['my-1', 'mx-1', 'border', 'border-primary', 'rounded-lg'],
            bTabLinkClasses: ['px-2', 'py-3', 'text-center']
        }
    }
}
</script>
